import { render, staticRenderFns } from "./EocViewBadgesAlerts.vue?vue&type=template&id=139bb53a&"
import script from "./EocViewBadgesAlerts.vue?vue&type=script&lang=js&"
export * from "./EocViewBadgesAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports